export const dateValues = [
  'Trending 7 Days',
  'Trending 30 Days',
  'Trending 3 Months',
  'Trending 6 Months',
  'Trending 1 Year',
];
export const dateDisplayNames = ['7 Days', '1 Month', '1 Quarter', '1 Year'];
export const dateShortDisplayNames = ['7d', '1m', '1q', '1y'];
export const dateSubstractNumbers = [7, 30, 3, 1];
export const dateSubstractMeasures = ['day', 'day', 'month', 'year'];
